/* Locale-aware For You links. No catalogue fetch or paid app required. */
(function () {
  'use strict';
  var locale = (document.documentElement.lang || 'en').toLowerCase();
  var prefix = locale.indexOf('fr') === 0 ? '/fr' : '';
  var profileKey = 'carole_style_profile';
  function complete() {
    try {
      var p = JSON.parse(localStorage.getItem(profileKey) || 'null');
      return !!(p && p.v === 2 && p.done === true && p.gender && Array.isArray(p.families) && p.families.length && Array.isArray(p.topSizes) && p.topSizes.length);
    } catch (e) { return false; }
  }
  function target() { return prefix + (complete() ? '/pages/for-you' : '/pages/style-quiz'); }
  function isForYou(a) {
    if (!a || !a.getAttribute('href')) return false;
    try {
      var u = new URL(a.getAttribute('href'), location.origin);
      return u.origin === location.origin && !u.searchParams.has('view') && /^(?:\/fr)?\/pages\/for-you\/?$/.test(u.pathname);
    } catch (e) { return false; }
  }
  function update() {
    document.querySelectorAll('a[href],a[data-carole-for-you]').forEach(function (a) {
      if (isForYou(a) || a.hasAttribute('data-carole-for-you')) {
        a.setAttribute('data-carole-for-you', '');
        a.setAttribute('href', target());
        a.removeAttribute('target');
      }
    });
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[data-carole-for-you]');
    if (!a) return;
    try { sessionStorage.removeItem('carole_box_return'); } catch (err) {}
    a.setAttribute('href', target());
  }, true);
  document.addEventListener('DOMContentLoaded', update);
  document.addEventListener('shopify:section:load', update);
  window.addEventListener('pageshow', update);
  window.addEventListener('storage', function (e) { if (e.key === profileKey) update(); });
})();
